import { useEffect } from 'react';

import { queryOptions, useQuery } from '@tanstack/react-query';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { Sidebar } from '@components/Sidebar';
import { ScrollArea } from '@components/ui/scroll-area';
import { useAuth } from '@contexts/auth';
import { EQueryKeys } from '@enums/queryKeys.enum';
import backendHttpClient from '@services/_httpClient/backend.http-client';
import { sessionService } from '@services/sessions/service';

const sessionQueryOptions = () =>
  queryOptions({
    refetchOnWindowFocus: false,
    queryKey: [EQueryKeys.Session],
    queryFn: () => sessionService.getInfo(),
    staleTime: 1000 * 60,
  });

export const Route = createFileRoute('/_layout')({
  beforeLoad: ({ context }) => {
    const isAuthenticated = !!context.auth.authorization.token;
    if (!isAuthenticated) {
      throw redirect({
        to: '/sign-in',
      });
    }
    backendHttpClient.setBearerToken(context.auth.authorization.token!);
  },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(sessionQueryOptions());
  },
  component: RootLayout,
});

function RootLayout() {
  const { data } = useQuery(sessionQueryOptions());

  const { onLogout, onSetUser } = useAuth();

  useEffect(() => {
    if (!data?.isActive) {
      onLogout('/under-review');
      return;
    }
    onSetUser(data);
  }, [onLogout, onSetUser, data]);

  return (
    <div className="bg-primary grid min-h-screen grid-cols-[auto_1fr]">
      <Sidebar />

      <ScrollArea className="max-h-dvh">
        <main className="bg-background min-h-dvh min-w-full rounded-tl-3xl rounded-bl-3xl p-3 shadow-2xl">
          {/* <WarningBanner /> */}
          <div className="p-4">
            <Outlet />
          </div>
        </main>
      </ScrollArea>
    </div>
  );
}
